import _ from 'lodash';

const TWIA_COMPANY_CODE = '2001_00001';

function missingParam($state) {
  const company = _.get($state, 'params.company');
  return company === undefined || company === null;
}

function isTWIAParam($state) {
  return _.get($state, 'params.company') === TWIA_COMPANY_CODE;
}

function isTWIACompany(uwCompanyCode) {
  return _.get(uwCompanyCode, 'value.code') === TWIA_COMPANY_CODE;
}

export default {
    missingParam,
    isTWIAParam,
    isTWIACompany
}